import React from 'react';
import PageContainer from '../../@layout/PageContainer';
import HeaderBar from '../HeaderBar';
import useKeyLessonPreview from '../hooks/use-key-lesson-preview';

const PreviewListContainer: React.FC<any> = ({ children, ...props }) => {
  const { error, loading } = useKeyLessonPreview();

  return (
    <PageContainer error={error} loading={loading}>
      <HeaderBar {...props} />
      {children}
    </PageContainer>
  );
};

export default PreviewListContainer;
